import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ErrorBoundary from './components/ErrorBoundary'
import { installClientErrorHandlers } from './lib/clientErrors'
import { installNativeBridge } from './lib/nativeBridge'
import App from './App'
import './index.css'

// Before anything renders: uncaught exceptions and unhandled rejections (which no React
// boundary can catch) start reporting to the clientErrors collection.
installClientErrorHandlers()
// Inside the iPad app, expose CoreNFC as window.InCiteNative. Before render, so the sign-in
// screen's feature check sees it on first paint rather than showing the typed-id fallback and
// swapping to a badge button a moment later. A no-op in a browser.
installNativeBridge()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
)
